import { render, staticRenderFns } from "./admAutorizaciones.vue?vue&type=template&id=4d14a9d2&scoped=true"
import script from "./admAutorizaciones.vue?vue&type=script&lang=js"
export * from "./admAutorizaciones.vue?vue&type=script&lang=js"
import style0 from "./admAutorizaciones.vue?vue&type=style&index=0&id=4d14a9d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d14a9d2",
  null
  
)

export default component.exports